import React from 'react';
import { useTranslation } from 'react-i18next';
import Lottie from "lottie-react";

// 1. Importando as animações Lottie locais
import techAnimationData from '../assets/lottie-tech.json';
import financeAnimationData from '../assets/lottie-finance.json';
import healthAnimationData from '../assets/lottie-health.json';

// Ícone de Check para a lista de benefícios (mantido)
const CheckIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500 mr-3 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>;

const WhoBenefits = () => {
    const { t } = useTranslation();

    const beneficiaries = [
        // 2. Trocando os ícones estáticos pelos dados das animações Lottie
        { animationData: techAnimationData, nameKey: 'benefits_cat1_name', descKey: 'benefits_cat1_desc', bullets: ['benefits_cat1_bullet1', 'benefits_cat1_bullet2', 'benefits_cat1_bullet3'], aos_delay: "0" },
        { animationData: financeAnimationData, nameKey: 'benefits_cat2_name', descKey: 'benefits_cat2_desc', bullets: ['benefits_cat2_bullet1', 'benefits_cat2_bullet2', 'benefits_cat2_bullet3'], aos_delay: "200" },
        { animationData: healthAnimationData, nameKey: 'benefits_cat3_name', descKey: 'benefits_cat3_desc', bullets: ['benefits_cat3_bullet1', 'benefits_cat3_bullet2', 'benefits_cat3_bullet3'], aos_delay: "400" },
    ];
    
    return (
        <section id="who-benefits" className="py-20 bg-white">
            <div className="container mx-auto px-6">
                <div className="text-center mb-16" data-aos="fade-up">
                    <h2 className="text-4xl font-bold text-primary">{t('benefits_main_title')}</h2>
                </div>

                <div className="grid md:grid-cols-3 gap-8">
                    {beneficiaries.map((item, index) => (
                        <div 
                          key={index} 
                          className="bg-white rounded-lg border border-gray-200 shadow-lg transition-all duration-300 transform hover:-translate-y-2 hover:shadow-2xl flex flex-col overflow-hidden" // Adicionado overflow-hidden
                          data-aos="fade-up"
                          data-aos-delay={item.aos_delay}
                        >
                           <div className="p-8">
                                {/* 3. Usando o componente Lottie onde o ícone estava */}
                                <div className="h-40 mb-6 flex items-center justify-center">
                                    <Lottie animationData={item.animationData} loop={true} style={{ height: '100%' }}/>
                                </div>
                                <h3 className="text-2xl font-bold mb-3 text-primary text-center">{t(item.nameKey)}</h3>
                                <p className="text-gray-600 mb-6 text-center">{t(item.descKey)}</p>
                           </div>
                           
                           <div className="bg-gray-50 p-8 border-t border-gray-200 mt-auto rounded-b-lg">
                                <ul className="space-y-4">
                                    {item.bullets.map(bulletKey => (
                                        <li key={bulletKey} className="flex items-start">
                                            <CheckIcon />
                                            <span className="text-gray-700">{t(bulletKey)}</span>
                                        </li>
                                    ))}
                                </ul>
                           </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhoBenefits;